export default __webpack_public_path__ + "static/media/ipams-1.956fbff9.jpg";